import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_EXPORT_TASK_LIST,
  SET_EXPORT_TASK_PAGE_STATUS,
  EXPORT_TASK_DELET,
  EXPORT_TASK_RELOAD,
  EXPORT_TASK_CANCEL,
  SET_EXPORT_TASK_DOWNLOAD,
  SET_EXPORT_TASK_RELOAD,
} = SYSTEMSETTING;
// 通用前缀
const url = '/robot';

const actions = {
  // 系统设置-数据导出列表-列表
  getTableList(data) {
    return {
      type: GET_EXPORT_TASK_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/sync/export/list`,
          data,
        },
      },
    };
  },
  // 系统设置-数据导出列表-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_EXPORT_TASK_PAGE_STATUS,
      data,
    };
  },
  // 系统设置-数据导出列表-下载数据
  downloadSet(data) {
    return {
      type: SET_EXPORT_TASK_DOWNLOAD,
      data,
    };
  },
  // 系统设置-数据导出列表-下载数据
  reloadSet(data) {
    return {
      type: SET_EXPORT_TASK_RELOAD,
      data,
    };
  },
  // 任务管理-任务列表-取消
  stop(id) {
    return {
      type: EXPORT_TASK_CANCEL,
      payload: {
        request: {
          method: 'get',
          url: `${url}/sync/export/cancel?id=${id}`,
        },
      },
    };
  },
  // 任务管理-任务列表-重新开始
  reload(data) {
    return {
      type: EXPORT_TASK_RELOAD,
      payload: {
        request: {
          method: 'get',
          url: `${url}/sync/export/reStart${data}`,
        },
      },
    };
  },
  // 任务管理-任务列表-删除
  delet(id) {
    return {
      type: EXPORT_TASK_DELET,
      payload: {
        request: {
          method: 'get',
          url: `${url}/sync/export/delete?id=${id}`,
        },
      },
    };
  },
};

export default actions;
